import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private currentLanguage: 'ar' | 'en' = 'ar';

  private readonly isBrowser: boolean;

  constructor(
    private translate: TranslateService,
    @Inject(PLATFORM_ID) platformId: object
  ) {

    this.isBrowser = isPlatformBrowser(platformId);

    // اللغة الافتراضية
    this.translate.setFallbackLang('ar');

    if (this.isBrowser) {

      const savedLanguage =
        localStorage.getItem('language');

      if (
        savedLanguage === 'ar' ||
        savedLanguage === 'en'
      ) {
        this.currentLanguage = savedLanguage;
      }

      this.translate.use(this.currentLanguage);

      this.setDirection(this.currentLanguage);

    } else {

      // SSR
      this.translate.use('ar');

    }
  }

  changeLanguage(lang: 'ar' | 'en'): void {

    this.currentLanguage = lang;

    this.translate.use(lang);

    if (this.isBrowser) {

      localStorage.setItem('language', lang);

      this.setDirection(lang);
    }
  }

  toggleLanguage(): void {

    const newLanguage =
      this.currentLanguage === 'ar'
        ? 'en'
        : 'ar';

    this.changeLanguage(newLanguage);
  }

  getLanguage(): 'ar' | 'en' {
    return this.currentLanguage;
  }

  private setDirection(lang: 'ar' | 'en'): void {

    if (!this.isBrowser) {
      return;
    }

    document.documentElement.lang = lang;

    document.documentElement.dir =
      lang === 'ar' ? 'rtl' : 'ltr';
  }
}